<main id="db-wrapper" class="bg-light">

    <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  
    <section id="page-content">
      <div class="header">
        <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
        <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
      </div>
  
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{'user_contacts' | translate}}
                </h1>
                <div [innerHTML]="'privacy_message' | translate" style="color:#000 !important;"></div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="row">
            <div class="col-lg-12" *ngIf="!loading">
                <div class="d-flex justify-content-center">
                  <div class="my-5" *ngIf="pendingContacts.length==0">
                    <button class="btn btn-primary me-3" (click)="loadContacts()">
                      {{'syncContacts' | translate}}
                    </button>
                </div>
                <div class="my-5" *ngIf="pendingContacts.length>0">
                  <button class="btn btn-primary me-3 " (click)="ProcessContact(userId)">
                    {{'processSyncContacts' | translate}}
                  </button>
               </div>
               <div class="my-5" *ngIf="myContacts.length>0">
                <button class="btn btn-danger" (click)="DeleteAllContact(userId)">
                  {{'deleteAllContacts' | translate}}
                </button>
              </div>
              </div>
            </div>
            <div class="col-lg-12" *ngIf="loading">
              <div class="d-flex justify-content-between">
                <div class="d-grid my-5" >
                  <button class="btn btn-primary" >
                    {{'loading' | translate}}
                  </button>
               </div>

              </div>
          </div>
          <div class="col-xxl-12 col-md-12 mb-8">
            <p-scrollPanel [style]="{ width: '100%', height: '450px' }">
              <div class="contacts-container">
                <h2>
                  {{'yourContactsInfo' | translate}}
                </h2>
                <div *ngFor="let contact of myContacts" class="card p-4 mb-3">
                  <h3>{{ contact.displayName}}</h3>     
                  <div *ngIf="contact.urls?.length">
                    <strong>URLs:</strong>
                    <ul>
                        <li *ngFor="let url of contact.urls">
                            <a [href]="'https://' + url" target="_blank">{{ url }}</a>
                        </li>
                    </ul>
                </div>
                  <div *ngIf="contact.organization">
                    <strong>{{'COMPANY' | translate}}:</strong> {{ contact.organization }} <br>
                    <strong>{{'jobTitle' | translate }}:</strong> {{ contact.givenName }}
                  </div>
                  <button class="btn btn-danger mt-3" *ngIf="loading">Loading...</button>
                  <button class="btn btn-danger mt-3" *ngIf="!loading" (click)="DeleteContact(contact.id)">
                    {{'delete' | translate}}
                  </button>
                </div>
              
              </div>
              
            </p-scrollPanel>
            
              
          </div>
          <div class="col-lg-12 mb-8">
            <div class="pagination-controls text-center">
              <button class="btn btn-secondary" (click)="goToPrev(userId)" [disabled]="!canGoPrev">Previous</button>
              <button class="btn btn-primary ms-3" (click)="goToNext(userId)" [disabled]="!canGoNext">Next</button>
            </div>
          </div>
        </div>
        </div>
    </section>
  </main>
  <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
    <app-bottom-nav></app-bottom-nav>
  </div>